import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 35.41,
	height: 28.56,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M4.25 12.27h26.9a3.35 3.35 0 0 1 3.55 3.3v4.49a3.54 3.54 0 0 1-3.54 3.54H4.25A3.54 3.54 0 0 1 .7 20.06V15.8a3.54 3.54 0 0 1 3.54-3.54"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M4.25 12.5v.48h26.78a3 3 0 0 1 2.13.83 2.3 2.3 0 0 1 .83 1.77v4.25a3.4 3.4 0 0 1-.83 2.23 3 3 0 0 1-2.12.83H4.12a2.5 2.5 0 0 1-1.88-.83 3.4 3.4 0 0 1-.83-2.23v-4.25a3 3 0 0 1 .95-2 2.5 2.5 0 0 1 1.88-.83v-1.42A4.25 4.25 0 0 0 0 15.58v4.48a4.25 4.25 0 0 0 4.25 4.24h26.9a4.25 4.25 0 0 0 4.26-4.24V15.8a4.25 4.25 0 0 0-4.25-4.25H4.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "M26.61.94H8.21a2 2 0 0 0-1.34.25 2.8 2.8 0 0 0-.74 1.46L4.2 12.27h26.43L28.7 2.65A2.1 2.1 0 0 0 26.6.94"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M26.9 1.17V.23H8.23a3 3 0 0 0-1.8.64 2.3 2.3 0 0 0-.99 1.4v.23l-2.1 10.47H31.5L29.4 2.5v-.23a3 3 0 0 0-.98-1.64h.3a3 3 0 0 0-1.8-.64v1.43a1.4 1.4 0 0 1 .9.32h-.29a1.4 1.4 0 0 1 .5.81v.23l1.75 8.78H5.07l1.75-8.78v-.23c.07-.33.25-.38.5-.58a1.4 1.4 0 0 1 .9-.32H26.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M14.16 22.9h7.08v1.4h-7.08Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M13.33 22.89h1.42a.7.7 0 1 1 0 1.41h-1.42c-.39 0-.7-.08-.7-.48s.31-.93.7-.93m7.08 0h1.42a.7.7 0 1 1 0 1.41H20.4c-.39 0-.7-.08-.7-.48s.31-.93.7-.93m-2.83-.24a.7.7 0 1 1-.7.71.7.7 0 0 1 .7-.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "M7.79 22.9h.7A2.1 2.1 0 0 1 10.63 25v.71a2.1 2.1 0 0 1-2.12 2.13h-.71a2.1 2.1 0 0 1-2.13-2.13v-.7a2.1 2.1 0 0 1 2.13-2.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M7.79 22.89v.7h.7a1.4 1.4 0 0 1 1.42 1.42v.71a1.4 1.4 0 0 1-1.41 1.42h-.71a1.4 1.4 0 0 1-1.42-1.42v-.7A1.4 1.4 0 0 1 7.8 23.6v-1.42a2.83 2.83 0 0 0-2.83 2.83v.71a2.83 2.83 0 0 0 2.83 2.83h.7a2.83 2.83 0 0 0 2.84-2.83v-.7a2.83 2.83 0 0 0-2.83-2.84h-.71Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#eff8fd",
			d: "M26.9 22.9h.72A2.1 2.1 0 0 1 29.74 25v.71a2.1 2.1 0 0 1-2.12 2.13h-.71a2.1 2.1 0 0 1-2.13-2.13v-.7a2.1 2.1 0 0 1 2.13-2.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M26.9 22.89v.7h.72a1.4 1.4 0 0 1 1.41 1.42v.71a1.4 1.4 0 0 1-1.41 1.42h-.71a1.4 1.4 0 0 1-1.42-1.42v-.7a1.4 1.4 0 0 1 1.42-1.42v-1.42a2.83 2.83 0 0 0-2.83 2.83v.71a2.83 2.83 0 0 0 2.83 2.83h.7a2.83 2.83 0 0 0 2.84-2.83v-.7a2.83 2.83 0 0 0-2.83-2.84h-.71Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5edb3d",
			d: "M7.32 15.58a1.77 1.77 0 1 1-1.77 1.77 1.77 1.77 0 0 1 1.77-1.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6eee4d",
			d: "M7.08 15.58v.7c.59 0 1.3.48 1.3 1.07A1.07 1.07 0 0 1 7.3 18.4c-.58 0-1.29-.48-1.3-1.06a1.06 1.06 0 0 1 1.07-1.06v-1.42a2.5 2.5 0 0 0-2.48 2.48 2.7 2.7 0 0 0 2.71 2.48 2.3 2.3 0 0 0 2.25-2.48 2.5 2.5 0 0 0-2.48-2.48Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5edb3d",
			d: "M27.85 15.58a1.77 1.77 0 1 1-1.77 1.77 1.77 1.77 0 0 1 1.77-1.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6eee4d",
			d: "M27.62 15.58v.7c.58 0 1.29.48 1.29 1.07a1.07 1.07 0 0 1-1.06 1.06c-.59 0-1.3-.48-1.3-1.06a1.06 1.06 0 0 1 1.07-1.06v-1.42a2.5 2.5 0 0 0-2.48 2.48 2.7 2.7 0 0 0 2.7 2.48 2.3 2.3 0 0 0 2.26-2.48 2.5 2.5 0 0 0-2.48-2.48Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#01215a",
			d: "M13.33 17.23h8.5a.7.7 0 1 1 0 1.41h-8.5c-.4 0-.71-.09-.71-.48s.32-.93.7-.93m-4.46-5.71L19.9.5a.7.7 0 1 1 1 1l-11.01 11a.7.7 0 1 1-1-1Zm4.96 0L24.85.5a.7.7 0 1 1 1 1l-11.02 11a.7.7 0 1 1-1-1Z"
		})
	]
});
export default SvgCar;
